import React, { PureComponent } from 'react';
import NotificationSystem from 'react-notification-system';
import withNotify from '../common/withNotify';
import Bugsnag from '../helpers/bugsnag';

class Notify extends PureComponent {
  constructor(props) {
    super(props);
    this.notificationSystem = null;
  }

  addNotification = ({ message, type, time = 5 }) => {
    try {
      if (message !== '') {
        this.notificationSystem.addNotification({
          uid: message,
          // title: type.capitalize(),
          dismissible: true,
          autoDismiss: time,
          position: 'tc',
          message,
          level: type,
        });
      }

      if (type === 'error') {
        this.notificationSystem.addNotification({
          uid: message,
          dismissible: true,
          autoDismiss: time,
          position: 'tc',
          message,
          level: type,
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    try {
      const { notifyValue } = nextProps;
      this.addNotification(notifyValue);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    return (
      <div>
        <NotificationSystem
          ref={(refNotification) => {
            this.notificationSystem = refNotification;
          }}
        />
      </div>
    );
  }
}

export default withNotify(
  Notify
);
